module.exports = __webpack_public_path__ + "img/buddy_eyes-05.bda82fd3.svg";